import { FaIdCard } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import { MdDelete } from "react-icons/md";
import { ImProfile } from "react-icons/im";
import { Link, useParams } from "react-router-dom";
import Search from "../../Search/Search";
import Title from "../../Title/Title";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import { useDelete, useFetch, useFilter } from "../../../ApiS";
import Table, { TableButtonLink, TableOperation } from "../../Table";
import PopUpDelete from "../../PopUps/PopUpDelete (1)";
import { usePopUpsStore } from "../../../store/PopUpStore";
import { RiEditBoxFill } from "react-icons/ri";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import Pagination from "../../pagination/Pagination (1)";
import Add from "../../Buttons/Add";
import Loader from "../../Loader";

// interface Student {
//   first_name_ar: string;
//   first_name_en: string;
//   last_name_ar: string;
//   last_name_en: string;
//   father_name_ar: string;
//   father_name_en: string;
//   mother_name_ar: string;
//   mother_name_en: string;
//   birth_place_ar: string;
//   birth_place_en: string;
//   birth_date: string;
//   nationality_id: number;
//   id_number: number;
//   gender: string;
//   place_of_registration: string;
//   registration_number: string;
//   passport_number: string;
//   recruitment_division: string;
//   province_id: number;
//   university_id: number;
//   personal_picture: string;
//   password: string;
//   phone_number: string;
//   landline_number: string;
//   city_of_residence_id: number;
//   email: string;
//   permanent_address: string;
//   current_address: string;
//   type: string;
//   high_school_type: string;
//   high_school_certificate_source: string;
//   total_student_score: number;
//   total_certificate_score: number;
//   high_school_year: string;
//   differential_rate: string;
//   english_language_degree: string;
//   french_language_degree: string;
//   religious_education_degree: string;
//   high_school_certificate_language: string;
//   high_school_certificate_photo: string;
//   institute_name: string;
//   institute_specialization: string;
//   graduation_rate: number;
//   graduation_year: string;
//   institute_certificate_image: string;
//   institute_transcript_file: string;
//   document_decisive: string;
// }

interface Student {
  first_name_ar: string;

  last_name_ar: string;

  father_name_ar: string;

  mother_name_ar: string;

  id: string | number;
}

interface StudentsData {
  data: { data: Student[]; last_page: number };
}

const Students = () => {
  const { id } = useParams();
  const { setPopUpDelete, popUpDelete } = usePopUpsStore();
  const { searchParams, handleParamsClick, handleParamDelete } = useFilter();

  const operations: TableOperation[] = [
    {
      name: "edit",
      icon: RiEditBoxFill,
      link: true,
      onClick: () => {
        console.log("edit");
      },
    },
    {
      name: "delete",
      icon: FaRegTrashAlt,
      link: true,
      onClick: (id) => {
        setPopUpDelete([id, true]);
      },
    },
  ];

  const links: TableButtonLink[] = [
    {
      name: "المقررات",
      link: `/curriculums`,
      color: "green",
    },
  ];

  const search = searchParams.get("search");
  const { data, isLoading } = useFetch(
    `admin/students?page=${searchParams.get("page")}${
      search && `?search=${search}`
    }?sort_by=${searchParams.get("sort_by")}`,
    `admin/students?page=${searchParams.get("page")}?search=${searchParams.get(
      "search"
    )}?sort_by=${searchParams.get("sort_by")}`
  );
  console.log(data);

  const { mutation, deleteItem } = useDelete(
    () => window.location.reload(),
    () => console.log(mutation.error)
  );
  return (
    <>
      <Row>
        <Col>
          <Title title="حسابات الطلاب" />
        </Col>
      </Row>

      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder="رقم الطالب / اسم الطالب / اسم الاب"
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Table<Student>
            tableHeads={[
              "رقم الطالب",
              "اسم الطالب",
              " الكنية",
              "اسم الأب",
              "اسم الأم",
              "العمليات",
              "المقررات"
            ]}
            tableBody={data?.data?.data}
            keys={[
              "id",
              "first_name_ar",
              "last_name_ar",
              "father_name_ar",
              "mother_name_ar",
            ]}
            operations={operations}
            links={links}
            className="lg:min-w-[100px] md:min-w-[50px]"
          />
          <Pagination pageCount={data?.data?.last_page} />
          <PopUpDelete
            text="هل أنت متأكد من حذف هذا الطالب؟"
            onClickDelete={() => deleteItem(`admin/students/${popUpDelete[0]}`)}
          />
        </>
      )}
      <Add link={`${id ? ":id/edit" : "add"}`} />
    </>
  );
};

export default Students;
